export type Hook = 'save' | 'edit' | 'delete' | 'select' | 'load' | 'deleteAll' | 'deleteAllComments' | 'hover' |
                    'unhover' | 'scroll' | 'unselect' | 'selectTool' | 'config' | 'newPage' | 'removeAllByConfig' |
                    'disable' | 'reset';
export type Tool = 'comment' | 'highlight' | 'rectangle' | '';
  
export class SearchParams {
    entityId : string;
    entityType : string;
    fileId : string;
    page? : string;
    [key : string] : any;
}

export enum AnnotationType{
    'comment' = "CMT",
    'highlight' = "HL",
    'rectangle' = "RECT"
}
